import { formatDynamicFields } from 'utils/graphqlUtils'

export const grinScanFields = `
  id
  scanPairId
  applianceIndex
  treatmentTrackerData
  scanSummaryData
`

export const getGrinScanForScanTagging = fields => /* GraphQL */ `
  query GetGrinScan($id: ID!) {
    getGrinScan(id: $id) {
      ${formatDynamicFields(fields)}
    }
  }
`
